import CloseIcon from '@mui/icons-material/Close'
import { AppBar, Box, Container, IconButton, Stack, Toolbar, Typography } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import { DataGrid } from '@mui/x-data-grid'
import CustomButton from 'Components/CustomButton/CustomButton'
import * as React from 'react'
import { useState } from 'react'
import { makeGetRequest, makePostRequest } from 'utils/api'
import CreateGroup from './CreateGroupModal'
import EditContactGroup from './SelectAndModifyGroup'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8

export default function ManageGroup() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [contactGroupOpen, setContactGroupOpen] = React.useState(false)
  const [row, setRow] = useState({})
  const [open, setOpen] = React.useState(false)
  const [rows, setRows] = useState(100)
  const [page, setPage] = useState(0)
  const [groups, setGroups] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  const fetchGroups = async (pagination = '') => {
    let url = `/api/Social/get-groups/`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setGroups(response.data)
    }
    setTimeout(1000)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une contacts ')
    } else {
      fetchGroups()
      const response = await makePostRequest(
        '/api/Social/delete-group/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
    fetchGroups()
  }
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchGroups(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchGroups(url)
  }

  const handleClickOpen = async () => {
    setOpen(true)
    fetchGroups()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const columns = [
    {
      field: 'Name',
      headerName: 'Groupe',
      width: 360,

      editable: false,
    },
    {
      field: 'Description',
      headerName: 'Description',
      width: 360,
      editable: false,
    },
    {
      field: 'id',
      headerName: 'Contact',
      width: 360,
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{ color: 'blue', cursor: 'pointer' }}
            onClick={() => {
              setRow(params.row)
              setContactGroupOpen(true)
            }}
          >
            List of contacts
          </Box>
        )
      },
    },
  ]

  return (
    <>
      {/* LAP-733 (GE022) */}
      <CustomButton onClick={handleClickOpen}>{t('contacts.btnManageGroup')}</CustomButton>
      {contactGroupOpen && row && (
        <EditContactGroup
          id={row.id}
          groupName={row.Name}
          setContactGroupOpen={setContactGroupOpen}
        />
      )}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 27, 66, 0.9)',
            color: '#fff',
          },
        }}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ color: '#fff', backgroundColor: 'black' }}>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Gestion des groups de contacts
            </Typography>
          </Toolbar>
        </AppBar>
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            padding: '20px',
          }}
        >
          <div>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Gestion des groups de contacts
            </Typography>
          </div>
          <div>
            <CreateGroup fetchGroups={fetchGroups} />
            <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
          </div>
          <div
            style={{
              height: 750,
              width: '100% ',
              color: 'black',
              background: 'white',
              borderRadius: '5px',
            }}
          >
            <DataGrid
              columns={columns}
              rows={groups}
              // columns={columns}
              // rows={groups}
              // rowCount={groups !== undefined ? groups.length : 0}
              // pageSize={rows}
              // onPageSizeChange={handleRowsChange}
              // onPageChange={handlePageChange}
              // rowsPerPageOptions={[10, 20, 40, 80, 100]}
              // pagination
              onSelectionModelChange={(itm) => setSelectedRows([...itm])}
              // paginationMode="server"
              components={{
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    Aucune donnée trouvée
                  </Stack>
                ),
                NoResultsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    Aucune donnée trouvée
                  </Stack>
                ),
              }}
              checkboxSelection
            />
          </div>
        </Container>
      </Dialog>
    </>
  )
}
